<!-- @Author: ruiwang -->
<!-- @Date: 2024-02-25 12:12:44 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-29 14:16:39 -->

<template>
    <div class="container profile-page">
        <section>
            <h1 class="bold">
                会員情報
            </h1>
            <div class="b3 c-02 mt28">
                住所の変更をご希望される場合、お問い合わせよりご連絡ください。
            </div>
        </section>
        <template v-if="finance.kyc">
            <section class="flex mt28">
                <div class="info-card des-group mr28">
                    <div
                        v-for="(option, idx) in options1"
                        :key="idx"
                        class="des-group-row b3"
                    >
                        <div class="des-group-row-label bold">
                            {{ option.label }}
                        </div>
                        <div class="des-group-row-value">
                            {{ idx === 0 ? finance. userEmail : option.value }}
                        </div>
                    </div>
                </div>
                <div class="info-card des-group">
                    <div
                        v-for="(option, idx) in options2"
                        :key="idx"
                        class="des-group-row b3"
                    >
                        <div class="des-group-row-label bold">
                            {{ option.label }}
                        </div>
                        <div class="des-group-row-value">
                            {{ option.value }}
                        </div>
                    </div>
                </div>
            </section>
            <section class="section2 mt100">
                <h1 class="bold">
                    入金先口座情報
                </h1>
                <div>
                    <p class="b3 mt28">
                        投資申込後は、下記の口座へご本人名義でご入金をお願いいたします。
                    </p>
                    <p class="b3">
                        ご入金後、当社での着金確認およびマイページへの反映にお時間をいただくことがあります。また、振込手数料はお客さま負担となりますので、ご注意ください。
                    </p>
                    <p class="b3">
                        会員登録されているご本人の名義（下記の振込依頼人名）でのお振込みをお願いいたします。
                    </p>
                </div>
                <div class="info-card mt28">
                    <div class="des-group">
                        <div
                            v-for="(option, idx) in options3"
                            :key="idx"
                            class="des-group-row b3"
                        >
                            <div class="des-group-row-label bold">
                                {{ option.label }}
                            </div>
                            <div class="des-group-row-value">
                                {{ option.value }}
                            </div>
                        </div>
                    </div>
                    <div class="divider-line mt14" />
                    <h5 class="c-02 mt28">
                        ご入金時の注意事項
                    </h5>
                    <div class="c-03 mt28">
                        <p class="b3">
                            ①会員登録されているご本人の名義と異なる名義からお振込みされた場合、お客さまからのご入金として取り扱うことができず、組戻しの手続きが必要となります。組戻し手数料等はお客さまのご負担となりますのでご了承ください。
                        </p>
                        <p class="b3">
                            ②会員登録されているご本人の名義と同じ名義であれば、送金用口座としてご登録の銀行口座以外からでもご入金いただけます。
                        </p>
                        <p class="b3">
                            ③口座名義は正しく入力してください。受取人の口座名義【インスタキャッシュ（カ】が異なる場合、振込先金融機関にて正しい入金処理が行われないことがございます。
                        </p>
                        <p class="b3">
                            ④当社サービスは出資金のデポジット（事前入金）には対応しておりません。出資金は必ず、ファンドへの投資申込みが完了してから、申込額を過不足なくご入金ください。
                        </p>
                        <p class="b3">
                            ⑤お客さまの投資家用口座へのご入金は、通常、ご入金の翌営業日を目処に、投資家用口座の入金額および投資申込ファンドへ充当されマイページ上に反映されますが、16時以降や土日・祝日、年末年始等のお振込みはご入金および投資申込ファンドへの充当の反映にお時間をいただくことがございます。あらかじめご了承ください。
                        </p>
                    </div>
                </div>
            </section>
            <section class="mt100">
                <h1 class="bold">
                    出金先口座情報
                </h1>
                <div class="info-card des-group mt28">
                    <div
                        v-for="(option, idx) in options4"
                        :key="idx"
                        class="des-group-row b3"
                    >
                        <div class="des-group-row-label bold">
                            {{ option.label }}
                        </div>
                        <div class="des-group-row-value">
                            {{ option.value }}
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <div
            v-else
            class="info-card des-group mt28"
        >
            <div
                v-for="(option, idx) in options1.slice(0, 2)"
                :key="idx"
                class="des-group-row b3"
            >
                <div class="des-group-row-label bold">
                    {{ option.label }}
                </div>
                <div class="des-group-row-value">
                    {{ idx === 0 ? finance. userEmail : option.value }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

import {options1, options2, options3, options4, genOptions} from './options';
export default {
    name: 'ProfilePage',

    data() {
        return {
            options1: genOptions(options1),
            options2: genOptions(options2),
            options3: genOptions(options3),
            options4: genOptions(options4)
        };
    },

    computed: {
        ...mapState(['finance'])
    }
};
</script>

<style lang="scss" scoped>
.mt14 {
    margin-top: 0.14rem;
}

.mt28 {
    margin-top: 0.28rem;
}

.mr28 {
    margin-right: 0.28rem;
}

.mt100 {
    margin-top: 1rem;
}

.c-02 {
    color: $c-02;
}

.c-03 {
    color: $c-03;
}

.profile-page {
    h1 {
        color: $c-01;
    }

    .info-card {
        padding: 0.28rem 0.48rem 0.14rem;
        border-radius: 0.16rem;
        border: 1px solid $c-06;
    }

    .flex {
        display: flex;
    }

    .section2 {
        max-width: 7.26rem;
    }

    .divider-line {
        height: 0.01rem;
        background-color: $c-06;
    }
}
</style>

